import { QueryClient, focusManager, onlineManager } from '@tanstack/react-query';

/**
 * ONE query client: every module's server state lives here, keyed by
 * declared queryKeys, invalidated by the stream bridge -- never by
 * hand-rolled useState mirrors of the server.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The stream bridge is the freshness signal; background polling
      // would just be a worse version of it.
      refetchOnWindowFocus: false,
      retry: 1,
      // 'always': the default 'online' mode PAUSES queries on browser
      // network heuristics -- status pending, fetchStatus paused --
      // which the status dots render as a lying green "0 elements
      // loaded" instead of the server-asleep message (seen live with
      // the api down). Fail honestly; the reconnect bridge heals.
      networkMode: 'always',
    },
  },
});

// Dev-only introspection: the live cache and managers, reachable from
// the console (dynamic import() would mint a SECOND module instance
// under vite -- these handles are the app's own singletons).
if (import.meta.env.DEV) {
  const w = window as unknown as Record<string, unknown>;
  w.__queryClient = queryClient;
  w.__focusManager = focusManager;
  w.__onlineManager = onlineManager;
}
